import { Search } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { HierarchyBreadcrumb } from "@/components/layout/hierarchy-breadcrumb";
import { NotificationBadge } from "@/components/layout/notification-badge";

export function TopBar() {
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4 print:hidden">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 !h-4" />
      <HierarchyBreadcrumb />
      <div className="ml-auto flex items-center gap-1">
        <Button variant="ghost" size="sm" className="gap-2 text-muted-foreground" disabled>
          <Search className="size-4" />
          <span className="hidden text-xs sm:inline">
            <kbd className="rounded border bg-muted px-1.5 py-0.5 text-[10px] font-medium">⌘K</kbd>
          </span>
        </Button>
        <NotificationBadge />
      </div>
    </header>
  );
}
